<template>
  <path
    d="M0.33 8.205c-0.439 0.439-0.439 1.152 0 1.591l7.159 7.159c0.439 0.439 1.152 0.439 1.591 0s0.439-1.152 0-1.591l-6.364-6.364 6.364-6.364c0.439-0.439 0.439-1.152 0-1.591s-1.152-0.439-1.591 0l-7.159 7.159zM18 7.875h-16.875v2.25h16.875v-2.25z"
  ></path>
</template>
